import styled from "styled-components";

export const MoreDetailsTextDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-color: ${props => props.theme.components.gamingHistory.colors.background};
    align-self: stretch;
    color: ${props => props.theme.colors.textMiddleDark};
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
       flex-basis: 100%;
    }
    padding-right: 5px;
    margin-left: -12px;
    white-space: nowrap;
`
